const configs = {
  development: {
    apiBaseUrl: 'http://localhost:3100/api',
    //apiBaseUrl: 'https://operation.pulseinnotech.com/api',
  },
  production: {
    // In production, the API URL should be relative to handle same-origin deployments
    apiBaseUrl: '/api',
  }
};

const getApiConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return configs[env];
};

export default getApiConfig; 